<template>
  <div>
    <div class="message" v-if="!isHistory">
      <el-button type="text" class="fr history-link" @click="isHistory=true">消息发送记录</el-button>
      <br />
      <el-form label-width="100px" label-position="left" class="form">
        <el-form-item label="消息正文">
          <el-input
            type="textarea"
            v-model="sendData.content"
            placeholder="请输入消息正文"
            class="content"
          ></el-input>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input placeholder="请选择跳转方式" v-model="sendData.url" disabled class="link"></el-input>
          <!-- <zt-button type="primary" class="link-btn" plain @click="onSettingLinkClick">设置链接</zt-button> -->
          <CmsEntrySelectButton v-model="sendData.url" />
          
        </el-form-item>
        <el-form-item label="发送时间">
          <el-radio v-model="sendType" label="1">立即发送</el-radio>
          <el-radio v-model="sendType" label="2">定时发送</el-radio>
          <el-date-picker
            v-if="sendType=='2'"
            class="picker"
            v-model="sendData.send_time"
            type="datetime"
            placeholder="选择发送时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <zt-button type="primary" @click="submit" class="submit-btn">确定</zt-button>
      </el-form>
      <!-- <setting-link-dialog
        v-model="visible"
        :url="sendData.url"
        @change="onSettingChange"
        class="ignore-elements"
      /> -->
    </div>
    <div class="history" v-else>
      <zt-button type="primary" @click="isHistory=false">返回</zt-button>
      <div v-if="list.length>0">
        <template v-for="item of list">
        <div class="history-content" :key="item.id">
          <div class="left" :class="isOverTime(item.send_time)?'left-active':''">
            <span>
              <span v-if="isOverTime(item.send_time)">将于</span>
              <br v-if="isOverTime(item.send_time)"/>
              <span>{{formatDate(item.send_time*1000)}}</span>
              <br v-if="isOverTime(item.send_time)"/>
              <span v-if="isOverTime(item.send_time)">发送</span>
            </span>
          </div>
          <div class="right">
            <!-- <p class="title">标题</p> -->
            <p
              class="content"
              :class="more.indexOf(item.id)!=-1?'':'auto'"
              :ref="`content${item.id}`"
            >
              <content-text :content="item.content" @showMore="showMore(item.id)"></content-text>
            </p>
            <span class="more" v-if="more.indexOf(item.id)!=-1">
              <svg-icon icon="down" :ref="`svg${item.id}`" class></svg-icon>
            </span>
            <span
              class="more ponit"
              v-if="more.indexOf(item.id)!=-1"
              @click="toggleContent(item.id,$event)"
            >查看全部</span>
          </div>
        </div>
      </template>
      </div>
      <template v-else>
        <div class="empty">
            <svg-icon icon="message_empty" />
            <p class="gray">暂无消息</p>
          </div>
      </template>
      <!-- 分页器 -->
      <div class="pagination">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagination.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.recordcount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { taoke_message_list, taoke_message_send } from '@/api/message';
import { diffStamp, formatDate } from '@/utils/date';
import contentText from './components/contentText';
// import SettingLinkDialog from "@/views/cmsWebSite/components/config/advert/components/SettingLinkDialog";
import { CmsEntrySelectButton } from '@/components/CmsEntrySelect'
export default {
  components: {
    // SettingLinkDialog,
    contentText,
    CmsEntrySelectButton,
  },
  data: () => ({
    loading:false,
    pagination: {
      page: 1, // 当前页
      pagesize: 10, // 每页大小
      pagecount: 1, // 总页数
      recordcount: 40, // 总条数
    },
    diffStamp,
    formatDate,
    list: [],
    sendData: {
      content: '',
      url: '',
      send_time: '',
    },
    content:
      '这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容',
    isHistory: false,
    sendType: '1',
    // visible: false,
    url: '',
    sentTime: '',
    more: [],
  }),
  watch:{
    isHistory(val) {
      if(val) {
        this.getList()
      }
    },
  },
  methods: {
    isOverTime(time) {
      return time>parseInt(Date.now() / 1000)
    },
    // 切换页面大小
    onSizeChange(pagesize) {
      this.pagination.pagesize = pagesize;
      this.getList();
    },

    // 切换页面
    onCurrentChange(page) {
      this.pagination.page = page;
      this.getList();
    },
    getList() {
      this.loading = true;
      
      let data = {
        page:this.pagination.page,
        num:this.pagination.pagesize,
      }
      taoke_message_list({
        ...data,
      }).then(({data}) => {
        if(data.error_code==0) {
          this.list= data.info;
          this.pagination.recordcount = data.num;
          this.pagination.pagecount = data.page_max
          this.loading = false
        }else{
          this.$message.error(data.error_message)
        }
      })
    },
    submit() {
      if (this.sendType == 1) {
        //立即发送
        this.sendData.send_time = '';
      }
      if (this.sendData == '') {
        this.$message.error('请输入消息内容');
        return;
      }
      taoke_message_send({
        ...this.sendData,
      }).then(({ data }) => {
        if (data.error_code == 0) {
          this.sendData = {
            title: '',
            content: '',
            url: '',
            send_time: '',
          };
          this.$message.success('发送消息成功')
        }else{
          this.$message.error(data.error_message)
        }
      });
    },
    showMore(id) {
      this.more.push(id);
    },
    toggleContent(id, e) {
      let str = 'content' + id;
      let str2 = 'svg' + id;
      let svg = this.$refs[str2][0].$el;
      let content = this.$refs[str][0];
      let contentClass = this.$refs[str][0].getAttribute('class');
      if (!contentClass.includes(['content-active'])) {
        content.classList.add('content-active');
        svg.classList.add('up');
        e.target.innerHTML = '收起';
      } else {
        content.classList.remove('content-active');
        svg.classList.remove('up');
        e.target.innerHTML = '查看全部';
      }
    },
    //设置链接
    // onSettingLinkClick() {
    //   this.visible = true;
    // },
    // 设置链接弹框选择内容改变
    // onSettingChange(e) {
    //   // this.$emit("update:url", e.originURL);
    //   this.sendData.url = e.originURL;
    // }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.up {
  transform: rotate(180deg);
}
.pagination{
  margin-top: 10px;
  text-align: right;
}
.empty {
  margin-top: 47px;
  text-align: center;
  .svg-icon--message_empty {
    width: 200px;
    height: 117px;
  }
  p {
    color: $theme-textsecond;
    font-size: 14px;
    margin-top: 15px;
  }
}
.message {
  .history-link {
    font-size: 12px;
  }
  .form {
    margin-top: 20px;
    .content /deep/ .el-textarea__inner {
      width: 420px;
      height: 185px;
      border-radius: 2px;
      border: 1px solid rgba(228, 231, 237, 1);
    }
    .picker {
      margin-left: 20px;
    }
    /deep/ .el-input {
      display: inline-block;
      width: auto;
      margin-right: 20px;
    }
    /deep/ .el-button--primary.is-plain {
      background: #fff;
      &:hover {
        background: linear-gradient(135deg, #409eff 0%, #7d8aff 100%);
      }
    }
    /deep/ .el-form-item {
      margin-bottom: 60px;
    }
    .link /deep/ .el-input__inner {
      width: 290px;
    }
    .submit-btn {
      width: 139px;
      margin-top: -20px;
    }
  }
}
.history {
  .history-content {
    display: flex;
    width: 100%;
    flex-direction: row;
    padding: 16px;
    .left {
      width: 140px;
      flex: none;
      font-size: 12px;
      line-height: 17px;
      color: $theme-textsecond;
      display: flex;
      // align-items: center;
    }
    .left-active {
      color: #f18700;
    }
    .right {
      flex: 1;
      margin-left: 24px;
      padding-right: 56px;
      // align-items: center;
      .title {
        font-size: 16px;
      }
      .content {
        line-height: 22px;
        height: 65px;
        overflow: hidden;
      }
      .auto {
        height: auto;
      }
      .content-active {
        height: auto;
      }
      .more {
        float: right;
        margin-top: 5px;
        color: $theme;
      }
      .ponit {
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
}
</style>